import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/settings.svg'
import _imports_1 from '@/assets/leftarrow.svg'
import _imports_2 from '@/assets/rightarrow.svg'
import _imports_3 from '@/assets/training.svg'
import _imports_4 from '@/assets/monitoring.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3010179e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onMouseover", "onMouseleave"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "item-name leading-5 text-sm"
}
const _hoisted_6 = {
  key: 0,
  class: "item-name leading-5 text-sm text-white"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ml-8" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "item-name leading-5 text-sm"
}
const _hoisted_13 = { class: "bottomUl mb-16" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "fixed shadow z-50 bg-white w-40 p-4"
}
const _hoisted_16 = { class: "flex flex-row items-center cursor-pointer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icn h-6 w-6 ml-2"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-item-label-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nav-item-label active" }, "Training"),
  /*#__PURE__*/_createElementVNode("div", { class: "active-border" })
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mr-1 w-2/4 ml-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "",
    class: "icn h-6 w-6 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "nav-item-label-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "nav-item-label" }, "Workflow")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed h-full bg-primary sidenav flex flex-col z-50 justify-between", { 'w-40': _ctx.isSidebarToggle, 'w-12': !_ctx.isSidebarToggle }])
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, menuIndex) => {
        return (_openBlock(), _createElementBlock("li", {
          key: menuIndex,
          onClick: ($event: any) => (_ctx.navigate(menu.optionName, menu.optionRoute)),
          class: "cursor-pointer hover:bg-white"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.selectedOptionName == menu.optionName ? 'bg-whitegrey text-black font-bold' : 'text-lightgrey font-normal', "a"]),
            onMouseover: ($event: any) => (menu.hover = true),
            onMouseleave: ($event: any) => (menu.hover = false)
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["flex navchild", { 'px-2 py-1': _ctx.isSidebarToggle, 'px-1.5 py-1': !_ctx.isSidebarToggle }])
            }, [
              (_ctx.selectedOptionName != menu.optionName && !menu.hover)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: menu.defaultoptionImage,
                    class: _normalizeClass(["h-5 mr-2.5 icon", { 'w-3 ': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
                  }, null, 10, _hoisted_3))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: menu.colouredoptionImage,
                    class: _normalizeClass(["h-5 mr-2.5 icon", { 'w-3': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
                  }, null, 10, _hoisted_4)),
              (_ctx.isSidebarToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(menu.displayOptionName), 1))
                : _createCommentVNode("", true)
            ], 2)
          ], 42, _hoisted_2)
        ], 8, _hoisted_1))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "a",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTeam =!_ctx.showTeam))
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["flex navchild", { 'px-2 py-1': _ctx.isSidebarToggle, 'px-1.5 py-1': !_ctx.isSidebarToggle }])
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass(["h-5 mr-2.5 icon", { 'w-3 ': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
            }, null, 2),
            (_ctx.isSidebarToggle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Team"))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_ctx.showTeam)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, teamIndex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: teamIndex,
                    onClick: ($event: any) => (_ctx.navigated(team._id)),
                    class: "cursor-pointer hover:bg-white"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.selectedOptionName == team.teamName ? 'bg-whitegrey text-black font-bold' : 'text-lightgrey font-normal', "a"]),
                      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menu.hover = true)),
                      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menu.hover = false))
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["flex navchild", { 'px-2 py-1': _ctx.isSidebarToggle, 'px-1.5 py-1': !_ctx.isSidebarToggle }])
                      }, [
                        (_ctx.selectedOptionName != team.teamName)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: team.defaultoptionImage,
                              class: _normalizeClass(["h-5 mr-2.5 icon", { 'w-3 ': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
                            }, null, 10, _hoisted_10))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: team.colouredoptionImage,
                              class: _normalizeClass(["h-5 mr-2.5 icon", { 'w-3': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
                            }, null, 10, _hoisted_11)),
                        (_ctx.isSidebarToggle)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(team.teamName), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 34)
                  ], 8, _hoisted_9))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("ul", _hoisted_13, [
      _createElementVNode("li", null, [
        _hoisted_14,
        (_ctx.isSidebarToggle)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_1,
              class: "h-8 ml-32 icon leftarrow absolute cursor-pointer",
              alt: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSideMenuBar()))
            }))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_2,
              class: "h-8 icon ml-2 rightarrow absolute cursor-pointer",
              alt: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSideMenuBar()))
            }))
      ])
    ]),
    (_ctx.appsVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "flex flex-col w-2/4 items-center cursor-pointer",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.triggerNav('training')))
            }, _hoisted_19),
            _hoisted_20
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}